import { Directive, HostListener } from '@angular/core';
import * as screenfull from 'screenfull';

@Directive({
    selector: '[appToggleFullscreen]'
})
export class ToggleFullscreenDirective {
    @HostListener('click') onClick() {
      if (screenfull && screenfull.enabled) {
        screenfull.toggle();
      }
    }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/directives/toggle-full-screen.directive.ts